module.exports = __webpack_public_path__ + "img/logo.1dc0a9b7.png";